import { render, staticRenderFns } from "./AnswerInput.vue?vue&type=template&id=4f3d8968&scoped=true&"
import script from "./AnswerInput.vue?vue&type=script&lang=js&"
export * from "./AnswerInput.vue?vue&type=script&lang=js&"
import style0 from "./AnswerInput.vue?vue&type=style&index=0&id=4f3d8968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3d8968",
  null
  
)

export default component.exports